import * as gfunctions from '../../../js/generalFunctions';

CCL.atcAlcohol = {
  autoload: [
    ['initialDataLoad', $('#alcoholAtcModal').length > 0]
  ],

  initialDataLoad() {
    $('body').on('click', '.alcohol-atc-modal-open-button', (e) => {
      const prodId = $(e.currentTarget).data('productcode');
      this.loadAlcoholJsonData(prodId);
    });
  },

  collapseStateroom() {
    $('.collapsible-link').click((e) => {
      console.log('Inside collapseStateroom');
      $(e.currentTarget.parentElement.parentElement).find('.arrow-link img').toggleClass('time-conflict-img-rotate');
    });
  },
  loadAlcoholJsonData(prodId) {
    const token = $('#csrfSessionToken').data('csrf');
    let ajaxUrl = '';
    let ajaxType = '';
    const dataObj = { productCode: prodId };
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/alcohol-atc-modal.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/shop/cart/clp/modal';
      ajaxType = 'POST';
    }
    gfunctions.showLoader();
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      contentType: 'application/json',
      data: JSON.stringify(dataObj),
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      this.loadHtmlTamplate(response);
      gfunctions.hideLoader();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while fetching data');
    });
  },

  loadHtmlTamplate(jsonData) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: '/_ui/responsive/ccl/assets/templates/alcohol-atc-modal/alcohol-atc-modal.html'
    }).done((response) => {
      const html = gfunctions.createDynamicHTML(response, jsonData);
      $('#dynamicPackageAtcModal').empty().append(html);
      gfunctions.showModal('alcoholAtcModal');
      gfunctions.pdpGetSelectedData();
      gfunctions.checkboxCheck();
      this.variantAjax(jsonData);
      this.collapseStateroom();
      this.modalEvents();
    }).fail(() => {
      gfunctions.hideLoader();
      console.log('error while loading html');
    });
  },
  variantAjax(jsonData) {
    if ($('.atc-card-body').children('.common-plp-error-msg').length) {
      $('.static-qty').hide();
      $('.restrict-quantity').hide();
    } else {
      $('.static-qty').show();
      $('.restrict-quantity').show();
    }
    if ($('.flavor-wrap').length > 0) {
      const ac = $('.selectable-link')[0];
      $('.add-to-cart-sfp').attr('data-hasupsell', ac.dataset.hasupsell);
      const linkVal = $('.selectable-link')[0].innerHTML;
      $(ac).addClass('active').attr('aria-label', `active ${linkVal}`);
      // ON CLICK OF SELECTABLE LINK
      $('.selectable-wrap').on('click', '.selectable-link', (event) => {
        $('.restrict-quantity .quantity-input-1').val('1');
        $('.restrict-quantity .increment-btn-1').removeAttr('disabled');
        $('.restrict-quantity .decrement-btn-1').attr('disabled', 'disabled');
        $('.terms-conditions-btn').removeAttr('disabled');
        $('.add-to-cart-sfp').removeAttr('disabled');
        const selectedlink = $(event.target).innerHTML;
        $(event.target).attr('aria-label', `active ${selectedlink}`);
        gfunctions.pdpGetSelectedData();
        $('.stateroom-info .stateroom-check .parent-check').each((i, e) => {
          $(e.offsetParent).find('.quantity-input-1').val();
          $(e.parentElement).find('.stateroom-error-msg').html('');
          $(e).removeAttr('disabled');
          $(e.parentElement).removeClass('stateroom-disabled').removeClass('all-disabled');
          $(e.parentElement).find('.alcohol-error-msg').hide();
          $(e.parentElement).find('.guest-title').removeClass('guest-disabled');
          $(e.parentElement).find('.guests .guests-check').each((ind, ele) => {
            if ($(ele).find('.guest-error-msg')[0].innerHTML === '') {
              $(ele).removeClass('guest-disabled').removeClass('div-disabled');
              $(ele).find('.custom-control-input').removeAttr('disabled');
            }
          });
        });
        $('.selectable-link').removeClass('active');
        $(event.currentTarget).addClass('active');
        if (event.currentTarget.dataset.strikeoutprice !== '') {
          if ($('.atc-card-body .price').length > 1) {
            $('.atc-card-body .price:first-of-type').remove();
          }
          $('.atc-card-body .price').empty().html(`
          <div class="strikeout-text greytext">
            ${event.currentTarget.dataset.strikeoutprice}
          </div>
          <div>
            ${event.currentTarget.dataset.price}
          </div>
          `);
        } else {
          if ($('.atc-card-body .price').length > 1) {
            $('.atc-card-body .price:first-of-type').remove();
          }
          $('.atc-card-body .price').empty().html(event.currentTarget.dataset.price);
        }

        if (jsonData.variants) {
          const tempPromoData = jsonData.variants.filter(x => x.code === event.currentTarget.dataset.code);
          if (tempPromoData.length) {
            let tempHtmlCode = '';
            if (tempPromoData[0].promotionResultsData !== null) {
              tempPromoData[0].promotionResultsData.forEach(element => {
                tempHtmlCode += `<div class="best-seller general-best-seller" role="textbox" aria-label="${element.description}"
                          style="background-color: #10559a">
                          <span class="info-icon" aria-hidden="true">
                            <img src="/_ui/responsive/ccl/assets/icons/star_white.svg" alt="${element.description}" width="11"
                              height="12">
                          </span>
                          ${element.description}
                        </div>`;
              });

              $('.promo-texts').empty().html(tempHtmlCode);
            }
          }
        }

        const variantName = event.currentTarget.dataset.producttitle;
        const atcCode = event.currentTarget.dataset.variantcode;
        const moreDetails = event.currentTarget.dataset.producturl;
        const hasUpsell = event.currentTarget.dataset.hasupsell;
        const imgUrl = event.currentTarget.dataset.imageurl;
        $('.atc-card-body .title').html(variantName);
        if (imgUrl) {
          $('.atc-card-image img').attr('src', `${imgUrl}&w=224&h=128`);
        }
        $('.atc-card-image').attr('aria-label', `${variantName}`);
        $('.terms-conditions-btn').attr('data-productcode', atcCode);
        // $('.add-to-cart-sfp').attr('data-productcode', atcCode);
        // $('.add-to-cart-sfp').attr('data-hasupsell', hasUpsell);
        $('.alcohol-atc-modal-dialog .general-add-to-cart-btn').attr('data-productcode', atcCode);
        $('.alcohol-atc-modal-dialog .general-add-to-cart-btn').attr('data-hasupsell', hasUpsell);
        const dataObj = {
          variantId: atcCode
        };
        $.ajax({
          type: 'GET',
          url: '/shop/getconflictmessage',
          contentType: 'application/json',
          data: dataObj
        }).done((res) => {
          $('.stateroom-info .stateroom-check .parent-check').each((i, e) => {
            $.each(res.conflictsMap, (key, value) => {
              if (e.id === key) {
                $(e.parentElement).find('.guest-title').addClass('guest-disabled');
                $(e.parentElement).find('.stateroom-error-msg').html(value);
                $(e).attr('disabled', 'disabled').removeAttr('checked');
                $(e.parentElement).addClass('stateroom-disabled').addClass('all-disabled');
                $(e.parentElement).find('.guests .guests-check').addClass('guest-disabled');
                $(e.parentElement).find('.guests .guests-check > input').removeAttr('checked').attr('disabled', 'disabled');
              }
            });
          });
          if (res.allConflict === 'true') {
            $('.terms-conditions-btn').attr('disabled', 'disabled');
            $('.add-to-cart-sfp').attr('disabled', 'disabled');
            $('.static-qty').hide();
            $('.restrict-quantity').hide();
            if ($('body .common-plp-error-msg').length > 0 && res.allConflictMsg !== '') {
              $('.common-plp-error-msg').html(res.allConflictMsg);
            } else if ($('body .common-plp-error-msg').length === 0 && res.allConflictMsg !== '') {
              const tempHtml = `<div class="common-plp-error-msg">${res.allConflictMsg}</div>`;
              $('.alcohol-Atc-modal-body').append(tempHtml);
            }
          } else {
            $('.terms-conditions-btn').removeAttr('disabled');
            // $('.add-to-cart-sfp').removeAttr('disabled');
            $('.common-plp-error-msg').empty();
            $('.static-qty').show();
            $('.restrict-quantity').show();
          }
          gfunctions.hideLoader();
        }).fail(() => {
          gfunctions.hideLoader();
          console.log('Something went wrong in variant ajax');
        });
      });
    }
  },

  modalEvents() {
    const modalEl = $('#alcoholAtcModal');

    modalEl.find('button.close').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.general-continue-shopping').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        if (modalEl.find('.general-add-to-cart-btn:disabled').length > 0) {
          const firstFocusable = gfunctions.getFocusableElements(modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.general-add-to-cart-btn').focus();
        }
      }
    });
    modalEl.find('.general-add-to-cart-btn').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        const firstFocusable = gfunctions.getFocusableElements(modalEl);
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-alcohol-atc-modal/alcohol-atc-modal.js